import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { id } from "./id";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      order: number;
      subject_id: number;
      assessment_id: number;
      name: string;
    }>;
  }>("/setup/topics", { params });
};

const post = function (data: {
  order: number;
  subject_id: number;
  assessment_id: number;
  name: string;
}) {
  return api.post("/setup/topics", data);
};

export const topics = {
  get,
  post,
  id,
};
